import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export function FirstSteps() {
  const { user } = useAuth();
  const key = user ? `first-steps-hidden-${user.id}` : "";
  const [hidden, setHidden] = useState(() => !!key && localStorage.getItem(key) === "1");
  const [done, setDone] = useState<{ budget: boolean; accounts: boolean } | null>(null);
  useEffect(() => {
    if (hidden) return;
    Promise.all([api.get<unknown[]>("/budget-items"), api.get<{ accounts: unknown[] }>("/accounts")])
      .then(([b, a]) => setDone({ budget: b.data.length > 0, accounts: a.data.accounts.length > 0 })).catch(() => undefined);
  }, [hidden]);
  if (hidden || !done || (done.budget && done.accounts)) return null;
  const steps = [{ ok: done.budget, label: "Arma tu presupuesto", to: "/presupuesto" }, { ok: done.accounts, label: "Agrega tus cuentas", to: "/cuentas" }];
  return (
    <div className="fade-up mb-6 rounded-[14px] border border-[#C9A84C]/50 bg-amber-50/60 p-5" data-testid="first-steps">
      <div className="flex items-start justify-between gap-3">
        <p className="font-display font-bold text-[#1B2A4A]">Primeros pasos</p>
        <button onClick={() => { localStorage.setItem(key, "1"); setHidden(true); }} aria-label="Saltar" className="text-slate-400 hover:text-slate-600" data-testid="first-steps-dismiss"><X className="h-4 w-4" /></button>
      </div>
      <ul className="mt-3 flex flex-col gap-2 sm:flex-row sm:gap-6">
        {steps.map((s) => (
          <li key={s.to}><Link to={s.to} className={`flex items-center gap-2 text-sm font-medium ${s.ok ? "text-slate-400 line-through" : "text-[#1B2A4A] hover:underline"}`} data-testid={`first-step-${s.to.slice(1)}`}>
            {s.ok ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <Circle className="h-4 w-4 text-amber-600" />}{s.label}
          </Link></li>
        ))}
      </ul>
    </div>
  );
}
